<template>
  <div>
    <v-card
      flat
      class="rounded-lg"
      :disabled="!course.training"
      @click="navigateToCourseDetailsPage(course)"
    >
      <v-row class="ps-4 ma-0" align="center">
        <v-col cols="12" sm="4" class="px-0">
          <div class="font-weight-light">
            <div class="d-flex flex-row justify-start flex-md-row align-center">
              <v-img
                class="rounded-lg"
                max-width="130"
                max-height="100%"
                height="80"
                :src="
                  course.training && course.training.images
                    ? getImage(course.training.images)
                    : null
                "
                lazy-src="@/app/core-module/assets/images/logo_placeholder.png"
                cover
              />

              <div
                class="ms-3 me-0 me-md-3 align-center"
                style="text-align: start"
              >
                <p
                  class="
                    text--left
                    ma-0
                    subtitle-1
                    textLight--text
                    text-ellipse-2
                  "
                  style="opacity: 70%; max-height: 80px"
                >
                  {{
                    course.training
                      ? getLocalisedValue(course.training.title)
                      : "-"
                  }}
                </p>
              </div>
            </div>
          </div>
        </v-col>

        <v-col cols="6" sm="2" class="px-0">
          <div class="d-flex justify-center">
            <h5 class="primary--text">{{ course.totalContents }}</h5>
          </div>
        </v-col>

        <v-col cols="6" sm="2" class="px-0">
          <course-progress :data="course.progress" :loading="loading" />
        </v-col>

        <v-col cols="6" sm="2" class="px-0">
          <div class="font-weight-light">
            <template v-if="$vuetify.breakpoint.xs">
              <span>Start date</span> <br />
            </template>

            {{
              course.startDate
                ? moment(parseInt(course.startDate)).format("DD MMM YYYY")
                : "-"
            }}
          </div>
        </v-col>

        <v-col cols="6" sm="2" class="px-0">
          <div class="font-weight-light" :class="dueDateClassStyle">
            <template v-if="$vuetify.breakpoint.xs">
              <span>End date</span> <br />
            </template>

            <v-icon v-if="dueDateClassStyle.length" :class="dueDateClassStyle">
              mdi-alert-outline
            </v-icon>

            {{
              course.endDate
                ? moment(parseInt(course.endDate)).format("DD MMM YYYY")
                : "-"
            }}
          </div>
        </v-col>
      </v-row>
    </v-card>
  </div>
</template>

<script>
import CourseProgress from "./CouresCircularProgress.vue";

export default {
  components: {
    CourseProgress,
  },
  props: {
    course: {
      type: Object,
      required: true,
    },
    loading: {
      type: Boolean,
    },
  },
  computed: {
    dueDateClassStyle() {
      return this.course.status !== "COMPLETED"
        ? this.course.days_difference < 0
          ? "error--text"
          : this.course.days_difference <= 5
          ? "warning--text"
          : ""
        : "";
    },
  },
  methods: {
    navigateToCourseDetailsPage(trainingRegistration) {
      if (!trainingRegistration.training) return;

      this.$router.push({
        name: "CourseDetails",
        params: { trainingRegistrationId: trainingRegistration._id },
      });
    },
  },
};
</script>
